import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const depositChequeApi = async (reqObj) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.chequeDashboard.depositCheque,
    reqObj
  );
};

export const autoCancelChequeApi = async (applicationId) => {
  return await fetchAllPromisedData(
    endpoint.cashManagement.chequeDashboard.getChequeDetails +
      `/${applicationId}`
  );
};

// fetch a
export const getAnswers = async (question) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.chequeDashboard.chats,
    { question: question }
  );
};
